import ActionValueModel from "../Actions/ActionValueModel";

export default class PointsValueModel extends ActionValueModel{
    public points: number;
    public alternative: any;

    constructor() {
        super();
        delete this.weight;
    }
}